<template>
  <div></div>
</template>

<script>
import {sessionStorage} from '@/utils/storage';
import g2wSimulive from '@/store/modules/g2w-simulive';
import windowUtils from '@/utils/window-utils';

export default {
  name: "AccessToken",

  created() {
    const webinarKey = sessionStorage.getItem('webinarKey');

    if (!this.$store.state.g2wSimulive) {
      this.$store.registerModule('g2wSimulive', g2wSimulive);
    }

    const parsedURL = windowUtils.getParsedUrl(true);
    const tokenish = parsedURL.hash.substring(1);

    this.$store.commit('g2wSimulive/setTokenish', {tokenish});

    this.$router.replace({
      name: 'preview',
      params: {
        webinarKey
      }
    });
  }
}
</script>

<style scoped>

</style>
